(() => {
  function init() {
    // Might be multiple Swipers on the page
    const slotSwipers = document.querySelectorAll('.component-dynamic-slot .swiper');
    if (slotSwipers.length == 0) return;
    slotSwipers.forEach((slotSwiper) => {
      new Swiper(slotSwiper, {
        loop: true,
        autoHeight: false, // Set to true to enable auto height (adaptive height for slides)
        slidesPerView: 1,
        spaceBetween: 0,
        zoom: false,
        autoplay: {
          delay: 2800,
          disableOnInteraction: true,
        },
      });
    });
  }

  // Check if the DOM is already loaded
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }
})();
